import { useEffect } from "react";
import axios from "axios";
import Hero from "@/components/Hero";
import ServicesSection from "@/components/ServicesSection";
import Testimonials from "@/components/Testimonials";
import AboutSection from "@/components/AboutSection";
import ContactSection from "@/components/ContactSection";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function HomePage() {
  useEffect(() => {
    // Seed testimonials on first load
    axios.post(`${API}/seed-testimonials`).catch(() => {});
  }, []);

  return (
    <div data-testid="home-page">
      <Hero />
      <ServicesSection />
      <Testimonials />
      <AboutSection />
      <ContactSection />
    </div>
  );
}
